/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GlobalEmbedComponent = {
  id?: number
  type?: GlobalEmbedComponent.type
  url?: string
}
export namespace GlobalEmbedComponent {
  export enum type {
    SPOTIFY = 'spotify',
    YOUTUBE = 'youtube',
    SOUNDCLOUD = 'soundcloud',
  }
}
